<template>
  <div class="container" data-cy="fob-point-form">
    <breadcrumbs
      :items="{
        ['Fob Points']: { path: '/admin/suppliers', query: { tab: 'FOB Points' } },
        [`${formType} Fob Point`]: true
      }"
    />
    <h1>{{ formType }} Fob Point</h1>

    <loading v-if="!loaded" />
    <template v-else>
      <FobPointFormElement :fobPoint="fobPoint" />
      <save-button
        class="my-3"
        :url="
          $route.params.fobPointId
            ? `/fobPoints/${$route.params.fobPointId}`
            : $route.query.supplierId
            ? `/suppliers/${$route.query.supplierId}`
            : `/fobPoints`
        "
        :method="$route.params.fobPointId ? 'put' : 'post'"
        :data="fobPoint"
        @onStartSave="onStartSave"
        @onError="onError"
        @save="$router.push(goBackUrl)"
      />

      <div class="text-danger card card-body bg-light mt-5" v-if="fobPoint.error">
        <pre v-if="fobPoint.error.response">
              {{ formatXml(fobPoint.error.response) }}
            </pre
        >
        <vue-json-pretty
          :path="'res'"
          v-if="fobPoint.error.request"
          :key="fobPoint.error.request"
          :data="{
            request:
              typeof fobPoint.error.request === 'string' ? JSON.parse(fobPoint.error.request) : fobPoint.error.request
          }"
        >
        </vue-json-pretty>
      </div>
    </template>
  </div>
</template>
<script>
import { formatXml } from '../../../../utils/formatXML';
import SaveButton from '../../../../components/SaveButton';
export default {
  name: 'FobPointForm',
  components: { SaveButton, FobPointFormElement: () => import('./FobPointFormElement') },
  data() {
    return {
      fobPoint: {}
    };
  },
  async created() {
    if (this.$route.params.fobPointId) {
      this.fobPoint = (await this.http.get(`/fobPoints/${this.$route.params.fobPointId}`)).data;
    }
    this.parseError();
    this.loaded = true;
  },
  computed: {
    goBackUrl() {
      const { supplierId } = this.$route.query;
      return supplierId ? `/admin/suppliers/${supplierId}` : { path: '/admin/suppliers', query: { tab: 'FOB Points' } };
    }
  },
  methods: {
    formatXml,
    onError(e) {
      this.fobPoint.error = e.data ? JSON.parse(e.data.message) : JSON.parse(e.message);
      this.parseError();
    },
    parseError() {
      if (this.fobPoint.error) {
        const s = this.fobPoint.error;
        this.fobPoint.error = {
          request: s.request,
          response: (typeof s.response === 'string' ? JSON.parse(s.response) : s.response).message
        };
      }
    },
    onStartSave(e) {
      this.fobPoint.error = null;
    }
  }
};
</script>
